var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h2',[_vm._v("Potential Users")]),_c('app-base',{ref:"crud",attrs:{"source":_vm.getPotentialUsers,"tableHeader":_vm.headers}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }